import { createSlice } from "@reduxjs/toolkit";
import {
  addOrupdatePlanOrder,
  getSubscribedMealList,
  onHoldPlan,
  onResumePlan,
  onRenewPlan,
  getCustomerMealPlan,
} from "../thunks/deiverAnorderThunk";

const initialState = {
  isPlanLoading: false,
  subscribedMeals: [],
  pagination: {
    current_page: 1,
    total_pages: 1,
    total_records: 0,
  },
};

const deliverAnorderSlice = createSlice({
  name: "planSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // 🔹 GET SUBSCRIBED MEALS
      .addCase(getSubscribedMealList.pending, (state) => {
        state.isPlanLoading = true;
      })
      .addCase(getSubscribedMealList.fulfilled, (state, action) => {
        state.isPlanLoading = false;

        state.subscribedMeals = action.payload?.data?.meal_plans || [];

        state.pagination = {
          current_page: action.payload?.data?.current_page,
          total_pages: action.payload?.data?.total_pages,
          total_records: action.payload?.data?.total_records,
        };
      })
      .addCase(getSubscribedMealList.rejected, (state) => {
        state.isPlanLoading = false;
      })

      // 🔹 ADD / UPDATE
      .addCase(addOrupdatePlanOrder.pending, (state) => {
        state.isPlanLoading = true;
      })
      .addCase(addOrupdatePlanOrder.fulfilled, (state, action) => {
        state.isPlanLoading = false;
        state.action = action.payload;
      })
      .addCase(addOrupdatePlanOrder.rejected, (state) => {
        state.isPlanLoading = false;
      })

      // On Hold
      .addCase(onHoldPlan.pending, (state) => {
        state.isPlanLoading = true;
      })
      .addCase(onHoldPlan.fulfilled, (state, action) => {
        ((state.isPlanLoading = false), (state.action = action.payload));
      })
      .addCase(onHoldPlan.rejected, (state) => {
        state.isPlanLoading = false;
      })

      // On resume
      .addCase(onResumePlan.pending, (state) => {
        state.isPlanLoading = true;
      })
      .addCase(onResumePlan.fulfilled, (state, action) => {
        ((state.isPlanLoading = false), (state.action = action.payload));
      })
      .addCase(onResumePlan.rejected, (state) => {
        state.isPlanLoading = false;
      })
      // On renew plan
      .addCase(onRenewPlan.pending, (state) => {
        state.isPlanLoading = true;
      })
      .addCase(onRenewPlan.fulfilled, (state, action) => {
        ((state.isPlanLoading = false), (state.action = action.payload));
      })
      .addCase(onRenewPlan.rejected, (state) => {
        state.isPlanLoading = false;
      })
      // Get customers meal plan

      .addCase(getCustomerMealPlan.pending, (state) => {
        state.isPlanLoading = true;
      })
      .addCase(getCustomerMealPlan.fulfilled, (state, action) => {
        ((state.isPlanLoading = false), (state.action = action.payload));
      })
      .addCase(getCustomerMealPlan.rejected, (state) => {
        state.isPlanLoading = false;
      });
  },
});

export default deliverAnorderSlice.reducer;
